import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const OrderDetailTitle = styled.p`
    margin: ${({ margin }) => (margin ? margin : '8px 0')};
    font-family: 'AvenirNextWorld Bold';
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '16px')};
    line-height: 20px;
    letter-spacing: 0px;
    color: #130e4a;
    opacity: 1;
    ${media.mobileDevice`
        display: ${({ display }) => (display ? display : 'block')};  
    `}
`;

export const OrderDetailFooterContainer = styled.div`
    width: 100%;
    display: flex;
    margin: 8px 0;
    align-items: center;
    justify-content: flex-start;
    ${media.mobileDevice`
        margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '15px')};  
    `}
`;
